// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1dlYN","content":"Consent_content__1jgtK","footer":"Consent_footer__2ryo7"};